var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Icons_Tractor",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.4 40 24.4 26 37.6 26 44.5 40 44.5 40 24.5 40 24.4 40 24.4 40ZM78.4 40 66.5 40 66.5 31C66.5 29.9 67.4 29 68.5 29L68.5 25C65.2 25 62.5 27.7 62.5 31L62.5 40 51.2 40C51.1 39.8 51 39.6 50.9 39.3L43 23.3C42 21.2 39.9 19.9 37.6 20L24.5 20C21.2 20 18.5 22.7 18.5 26L18.5 40 16.4 41.3C15.8 41.7 15.5 42.3 15.5 43L15.5 46C15.5 46.3 15.6 46.6 15.7 46.9 14.1 47.9 12.6 49 11.2 50.4 10.8 50.8 10.5 51.4 10.5 52 10.5 52.6 10.8 53.2 11.2 53.6 12 54.2 13.1 54.2 13.9 53.4 18.7 48.6 23.6 48 24.9 48L26.4 48C35.1 48 42.1 54.4 42.4 63L42.4 64.9C42.4 65.9 43.1 66.8 44.1 67 44.7 67.1 45.3 66.9 45.7 66.5 46.1 66.1 46.4 65.6 46.4 65L46.4 63 64 63C65.7 57.6 70.7 54 76.4 54 77.6 54 78.7 54.2 79.9 54.5 80.5 54.7 81.2 54.5 81.7 54.1 82.2 53.7 82.5 53.1 82.5 52.5L82.5 44C82.5 42.9 82.1 41.9 81.3 41.2 80.5 40.4 79.5 40 78.4 40Z",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4 70.5C22.5 70.5 19.4 67.4 19.4 63.5 19.4 59.6 22.5 56.5 26.4 56.5 30.3 56.5 33.4 59.6 33.4 63.5 33.4 67.4 30.3 70.5 26.4 70.5L26.4 70.5ZM26.4 51.5C20 51.5 14.7 56.5 14.4 62.9L14.4 63C14.4 63.2 14.4 63.3 14.4 63.5 14.4 70.1 19.8 75.5 26.4 75.5 33 75.5 38.4 70.1 38.4 63.5 38.4 63.3 38.4 63.2 38.4 63 38.2 56.6 32.9 51.5 26.4 51.5Z",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4 72C73.6 72 71.4 69.8 71.4 67 71.4 64.2 73.6 62 76.4 62 79.2 62 81.4 64.2 81.4 67 81.4 69.8 79.2 72 76.4 72ZM82.4 60.3C79.2 57.5 74.5 57.2 71.1 59.7 67.7 62.2 66.5 66.8 68.2 70.6 69.9 74.5 74.2 76.6 78.3 75.7 82.5 74.8 85.4 71.1 85.4 66.9 85.4 64.4 84.4 62 82.4 60.3L82.4 60.3Z",
    stroke: "#FFFFFF",
    fill: "#FFFFFF"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarm);
export default __webpack_public_path__ + "static/media/farm.2cc490a643117442127a35673dec15de.svg";
export { ForwardRef as ReactComponent };